/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { pdf } from "@react-pdf/renderer";
import { Button, Grid, Form, Divider, Dropdown, Segment, Dimmer, Loader } from "semantic-ui-react";
import MonitoringReport from "./MonitoringReport";
import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
import Utils from "../utilities/Utils";

const UtilsInstance = new Utils();

const dropdownOptions = [
  {
    key: Constants.CONFORM,
    value: Constants.CONFORM,
    text: Strings.CONFORM_STRING
  },
  {
    key: Constants.CONFORM_W_RESTRICTION,
    value: Constants.CONFORM_W_RESTRICTION,
    text: Strings.CONFORM_W_RESTRICTION_STRING
  },
  {
    key: Constants.NON_CONFORM,
    value: Constants.NON_CONFORM,
    text: Strings.NON_CONFORM_STRING
  }
];

class Report extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isGenerateReportDimmerActive: false,

      savedClients: [],
      savedExecutors: [],

      // User input data
      clientProjectName: "",
      clientNetworkName: "",
      clientLocation: "",
      clientCompanyName: "",
      clientAccountableName: "",
      clientAddress: "",
      clientCity: "",
      clientTel: "",
      executingCompanyName: "",
      executingAccountableName: "",
      executingTel: "",
      executingEmail: "",
      notes: "",
      conformity: "",

      measurementUptime: -1
    };
  }

  setGeneratingDimmerState = (isActive, showSuccessMessage = false) => {
    this.setState({ isGenerateReportDimmerActive: isActive }, () => {
      if (!isActive && showSuccessMessage) {
        alert(Strings.GENERATING_REPORT_SUCCESS);
      }
    });
  }

  downloadReport = async (reportDocument) => {
    const blob = await pdf(reportDocument).toBlob();
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    try {
      link.href = url;
      link.download = Strings.REPORT_EXPORT_NAME_PDF;
      document.body.appendChild(link);
      link.click();
    }
    finally {
      if (link.parentNode) {
        link.parentNode.removeChild(link);
      }
      URL.revokeObjectURL(url);
    }
  }

  // Verifies if the user has the credentials to be logged in
  // If he does he is re-directed to the configuration page
  // If he doesn't he is re-directed to the login page
  isUserLoggedIn = () => {
    if (sessionStorage.auth !== Constants.AUTH_STR) {
      this.props.history.push({ pathname: "/login" });
    }
  }

  formatToRelativeTime2 = (uptimeInSeconds) => {
    if (uptimeInSeconds !== undefined) {
      const uptimeInMillis = uptimeInSeconds * 1000;
      const timeNow = new Date().getTime();
      const whenWasTurnedOn = timeNow - uptimeInMillis;
      const dateWhenWasTurnedOn = new Date(whenWasTurnedOn);
      return this.getDateTimeSince2(new Date(dateWhenWasTurnedOn));
    }
  }

  getDateTimeSince2 = (target) => { // target should be a Date object
    let now = new Date(), yd, md, dd, hd, nd, sd, out = [];

    yd = now.getFullYear() - target.getFullYear();
    md = now.getMonth() - target.getMonth();
    dd = now.getDate() - target.getDate();
    hd = now.getHours() - target.getHours();
    nd = now.getMinutes() - target.getMinutes();
    sd = now.getSeconds() - target.getSeconds();

    if (md < 0) { yd--; md += 12; }
    if (dd < 0) {
      md--;
      dd += this.getDaysInMonth2(now.getMonth() - 1, now.getFullYear());
    }
    if (hd < 0) { dd--; hd += 24; }
    if (nd < 0) { hd--; nd += 60; }
    if (sd < 0) { nd--; sd += 60; }

    if (yd > 0) out.push(yd + Strings.YEAR + (yd === 1 ? "" : "s"));
    if (md > 0) {
      if (md === 1) {
        out.push(md + Strings.MONTH);
      }
      else {
        out.push(md + Strings.MONTHS);
      }
    }
    if (dd > 0) out.push(dd + Strings.DAY + (dd === 1 ? "" : "s"));
    if (hd > 0) out.push(hd + Strings.HOUR + (hd === 1 ? "" : "s"));
    if (nd > 0) out.push(nd + Strings.MINUTE + (nd === 1 ? "" : "s"));
    if (sd > 0) out.push(sd + Strings.SECOND + (sd === 1 ? "" : "s"));
    return out.join(" ");
  }

  getDaysInMonth2 = (month, year) => {
    if (typeof year == "undefined") year = 1999; // any non-leap-year works as default     
    let currmon = new Date(year, month),
      nextmon = new Date(year, month + 1);
    return Math.floor((nextmon.getTime() - currmon.getTime()) / (24 * 3600 * 1000));
  }

  hasInputTrafficErrors = (device) => {
    let numOfErrors = 0;

    for (let i = 0; i < device.ports.length; i++) {
      if (device.ports[i].inputErrors !== "") {
        numOfErrors += parseInt(device.ports[i].inputErrors);
      }
    }

    if (numOfErrors === 0) {
      return false;
    }
    else {
      return true;
    }
  }

  hasOutputTrafficErrors = (device) => {
    let numOfErrors = 0;

    for (let i = 0; i < device.ports.length; i++) {
      if (device.ports[i].exitErrors !== "") {
        numOfErrors += parseInt(device.ports[i].exitErrors);
      }
    }

    if (numOfErrors === 0) {
      return false;
    }
    else {
      return true;
    }
  }

  getDevicesWithTrafficErrors = (trafficData) => {
    let devices = {
      withInputTrafficErrors: [],
      withOutputTrafficErrors: []
    };

    for (let i = 0; i < trafficData.length; i++) {
      if (this.hasInputTrafficErrors(trafficData[i])) {
        devices.withInputTrafficErrors.push(trafficData[i]);
      }

      if (this.hasOutputTrafficErrors(trafficData[i])) {
        devices.withOutputTrafficErrors.push(trafficData[i]);
      }
    }

    return devices;
  }

  getNewest200Events = (log) => {
    let newest200Events = [];

    if (log.length > Constants.MAX_NUM_OF_LOG_EVENTS) {
      for (let i = 0; i < Constants.MAX_NUM_OF_LOG_EVENTS; i++) {
        newest200Events.push(log[i]);
      }
    }
    else {
      for (let i = 0; i < log.length; i++) {
        newest200Events.push(log[i]);
      }
    }

    return newest200Events;
  }

  // ----------------- Data retrieval functions ---------------- 
  retrieveMonitoringData = async (userInput) => {
    this.setGeneratingDimmerState(true);

    let promissesArray = [];

    // Start to fetch all data here, put the promisses returned in an array
    promissesArray.push(this.fetchReportData("config"));                // [0]
    promissesArray.push(this.fetchReportData("startTime"));             // [1]
    promissesArray.push(this.fetchReportData(""));                      // [2]
    promissesArray.push(this.fetchReportData("topology"));              // [3]
    promissesArray.push(this.fetchReportData("ping"));                  // [4]
    promissesArray.push(this.fetchReportData("traffic"));               // [5]
    promissesArray.push(this.fetchReportData("deviceStatistics"));      // [6]
    promissesArray.push(this.fetchReportData("log"));                   // [7]
    promissesArray.push(this.fetchReportData("homePage"));              // [8]
    promissesArray.push(this.fetchReportData("wifiConfig"));            // [9]
    promissesArray.push(this.fetchReportData("inventory"));             // [10]
    promissesArray.push(this.fetchReportData("maintenance"));           // [11]
    promissesArray.push(this.fetchReportData("graphicNetworkStatus"));  // [12]
    promissesArray.push(this.fetchReportData("wifiStatus"));            // [13]
    promissesArray.push(this.fetchReportData("configEth1"));            // [14]
    promissesArray.push(this.fetchReportData("eth1Status"));            // [15]

    // And wait until all of them have finished
    let resolvedPromisses = await Promise.all(promissesArray);

    let configData = resolvedPromisses[0];
    let startTime = resolvedPromisses[1].startTime;

    let nowMillis = Date.now();

    // Sort the livelist by IP
    let livelist = resolvedPromisses[2].sort((a, b) => {
      const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
      const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
      return num1 - num2;
    });

    // Sort  the topology by IP
    let topology = resolvedPromisses[3].sort((a, b) => {
      const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
      const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
      return num1 - num2;
    });

    // Then sort each port by port name
    for (let i = 0; i < topology.length; i++) {
      topology[i].connections = topology[i].connections.sort(
        UtilsInstance.sortBy(
          "selfPort",
          false,
          function (a) { return UtilsInstance.treatUppercase(a); }));
    }

    // Sort the ping devices by IP
    let pingDevices = resolvedPromisses[4].sort((a, b) => {
      const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
      const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
      return num1 - num2;
    });

    for (let i = 0; i < pingDevices.length; i++) {
      pingDevices[i].config_method = "";
    }

    let measurementUptime = this.formatToRelativeTime2(resolvedPromisses[5].uptime);

    // Sor traffic devices by IP
    let traffic = resolvedPromisses[5].devices.sort((a, b) => {
      const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
      const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
      return num1 - num2;
    });

    // Device Statistics
    let deviceStatistics = resolvedPromisses[6];
    // Network Statistics
    // Log data
    let log = resolvedPromisses[7].sort(UtilsInstance.sortBy("event", true, parseInt));
    // Uptime + Tag
    let homePageData = resolvedPromisses[8];
    // Wifi configuration
    let wifiStatus = resolvedPromisses[13].status;
    let wifiConfigData = "";

    if (wifiStatus === Constants.CONNECTED_STATUS) {
      wifiConfigData = resolvedPromisses[9];
    }
    else {
      wifiConfigData = {
        "wifiMode": "",
        "hiddenSSID": false,
        "wifiName": "",
        "wifiAddr": "",
        "wifiNetmask": "",
        "wifiGateway": "",
        "wifiDNS": "",
        "wifiPwd": ""
      };
    }

    let officeEthStatus = resolvedPromisses[15].status;
    let officeEthConfigData = "";

    if (officeEthStatus === Constants.CONNECTED_STATUS) {
      officeEthConfigData = resolvedPromisses[14];
    }
    else {
      officeEthConfigData = {
        "eth1Addr": "",
        "eth1DNS": "",
        "eth1Gateway": "",
        "eth1Mode": "",
        "eth1Netmask": ""
      };
    }
    // Inventory
    let inventory = resolvedPromisses[10].sort((a, b) => {
      const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
      const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
      return num1 - num2;
    });
    // Maintenance
    let maintenance = resolvedPromisses[11].sort((a, b) => {
      const num1 = Number(a.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
      const num2 = Number(b.ip.split(".").map((num) => (`000${num}`).slice(-3)).join(""));
      return num1 - num2;
    });

    let networkAvailability = this.getNetworkAvailability(resolvedPromisses[12]);

    let devicesWithTrafficErrors = this.getDevicesWithTrafficErrors(traffic);
    let newest200Events = this.getNewest200Events(log);

    livelist = this.addAditionalInfoToDevices(livelist, pingDevices, maintenance);
    inventory = this.addRoleToInventory(inventory, livelist);

    const reportDocument = (
      <MonitoringReport
        userInput={userInput}
        configData={configData}
        wifiConfigData={wifiConfigData}
        officeEthConfigData={officeEthConfigData}
        startTime={startTime}
        nowMillis={nowMillis}
        livelist={livelist}
        inventory={inventory}
        topology={topology}
        pingDevices={pingDevices}
        devicesWithInputTrafficErrors={devicesWithTrafficErrors.withInputTrafficErrors}
        devicesWithOutputTrafficErrors={devicesWithTrafficErrors.withOutputTrafficErrors}
        deviceStatistics={deviceStatistics}
        log={newest200Events}
        uptime={this.formatToRelativeTime2(homePageData.uptime)}
        tag={homePageData.networkTag}
        measurementUptime={measurementUptime}
        conformity={this.state.conformity}
        networkAvailability={networkAvailability}
      />
    );

    await this.downloadReport(reportDocument);
    this.setGeneratingDimmerState(false, true);
  }

  addAditionalInfoToDevices = (livelist, pingDevices, maintenance) => {
    let devicesCopy = JSON.parse(JSON.stringify(livelist));

    for (let i = 0; i < devicesCopy.length; i++) {
      let pingData = this.getPingData(devicesCopy[i], pingDevices);

      devicesCopy[i].availability = this.getDeviceAvailability(devicesCopy[i], maintenance);
      devicesCopy[i].pingAvg = pingData.pingAvg;
      devicesCopy[i].pingCurrent = pingData.pingCurrent;
      devicesCopy[i].lostPings = pingData.lostPings;
      devicesCopy[i].lostPingsPercentage = pingData.lostPingsPercentage;
    }

    return devicesCopy;
  }

  getPingData = (device, pingDevices) => {
    let pingData = {
      "pingAvg": "",
      "pingCurrent": "",
      "lostPings": "",
      "lostPingsPercentage": ""
    };

    for (let i = 0; i < pingDevices.length; i++) {
      if (pingDevices[i].mac === device.mac) {
        pingData = {
          "pingAvg": pingDevices[i].pingAvg,
          "pingCurrent": pingDevices[i].pingCurrent,
          "lostPings": pingDevices[i].lostPings,
          "lostPingsPercentage": pingDevices[i].lostPingsPercentage
        };
        return pingData;
      }
    }

    // If no device was found, return and empty ping data object
    return pingData;
  }

  getDeviceAvailability = (device, maintenance) => {
    for (let i = 0; i < maintenance.length; i++) {
      if (maintenance[i].mac === device.mac) {

        // The device availability is the percentage of time it was on "OK" status +
        // the percentage of time it was on "Alarme" status
        let availability = maintenance[i].percentageAvailable
          + maintenance[i].percentageDiagnostic;

        // Never let the availability be greater than 100%
        if (availability >= 100) {
          availability = 100;
        }

        return availability;
      }
    }
  }

  // The network availabilty is calculated this way:
  // Percentage of time the network was on OK status + percentage of the time the network was on DIAGNOSTIC status
  getNetworkAvailability = (availabilityData) => {
    return (availabilityData.percentageAvailable + availabilityData.percentageDiagnostic).toFixed(0).concat("%");
  }

  addRoleToInventory = (inventory, livelist) => {
    let devicesCopy = JSON.parse(JSON.stringify(inventory));

    for (let i = 0; i < devicesCopy.length; i++) {
      for (let j = 0; j < livelist.length; j++) {
        if (devicesCopy[i].mac === livelist[j].mac) {
          devicesCopy[i].role = livelist[j].role;
          break;
        }
      }
    }

    return devicesCopy;
  }

  fetchReportData = async (route) => {
    return await fetch(Constants.REQUEST_IP_ADDRESS + route, { mode: "cors" })
      .then(res => res.json())
      .then(data => data);
  }

  // ----------------- Event Handlers -----------------
  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  handleConformityDropdownItemClick = (event, info) => {
    this.setState({ conformity: info.value });
  }

  handleSubmit = () => {
    let clientImg = "";
    let executorImg = "";

    if (document.getElementById("client-img").files[0] !== undefined) {
      clientImg = URL.createObjectURL(document.getElementById("client-img").files[0]);
    }

    if (document.getElementById("executor-img").files[0] !== undefined) {
      executorImg = URL.createObjectURL(document.getElementById("executor-img").files[0]);
    }

    let userInput = {
      // Client info
      clientProjectName: this.state.clientProjectName,
      clientNetworkName: this.state.clientNetworkName,
      clientLocation: this.state.clientLocation,
      clientCompanyName: this.state.clientCompanyName,
      clientAccountableName: this.state.clientAccountableName,
      clientAddress: this.state.clientAddress,
      clientCity: this.state.clientCity,
      clientTel: this.state.clientTel,
      clientImg: clientImg,
      // Executing company info
      executingCompanyName: this.state.executingCompanyName,
      executingAccountableName: this.state.executingAccountableName,
      executingTel: this.state.executingTel,
      executingEmail: this.state.executingEmail,
      executorImg: executorImg,
      // Notes
      notes: this.state.notes,
      // Conformity
      conformity: this.state.conformity
    };

    this.retrieveMonitoringData(userInput).catch((error) => {
      console.error(error);
      this.setState({ isGenerateReportDimmerActive: false });
      alert(Strings.GENERATING_REPORT_ERROR);
    });
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.isUserLoggedIn();
  }

  render() {
    const {
      clientProjectName,
      clientNetworkName,
      clientLocation,
      clientCompanyName,
      clientAccountableName,
      clientAddress,
      clientCity,
      clientTel,
      executingCompanyName,
      executingAccountableName,
      executingTel,
      executingEmail,
      notes
    } = this.state;

    return (
      <div className="ts-config-subpage ts-report-page" style={divStyle} >

        <Grid columns={2} doubling stretched>
          <Grid.Column>
            <Segment className="ts-report-card">

              <Divider horizontal>{Strings.CLIENT_INFO}</Divider>
              <Form>
                <Form.Input label={Strings.PROJECT_NAME_1} name='clientProjectName' value={clientProjectName} onChange={this.handleChange} />
                <Form.Input label={Strings.NETWORK_NAME_1} name='clientNetworkName' value={clientNetworkName} onChange={this.handleChange} />
                <Form.Input label={Strings.LOCATION_1} name='clientLocation' value={clientLocation} onChange={this.handleChange} />
                <Form.Input label={Strings.COMPANY_NAME_1} name='clientCompanyName' value={clientCompanyName} onChange={this.handleChange} />
                <Form.Input label={Strings.RESPONSIBLE_NAME} name='clientAccountableName' value={clientAccountableName} onChange={this.handleChange} />
                <Form.Input label={Strings.ADDRESS} name='clientAddress' value={clientAddress} onChange={this.handleChange} />
                <Form.Input label={Strings.CITY} name='clientCity' value={clientCity} onChange={this.handleChange} />
                <Form.Input label={Strings.TEL} name='clientTel' value={clientTel} onChange={this.handleChange} />
                <Form.Input id="client-img" label={Strings.CLIENT_LOGO} type="file" accept=".png,.jpg,.jpeg" />
              </Form>
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment className="ts-report-card">

              <Divider horizontal>{Strings.EXECUTING_COMPANY_INFO}</Divider>

              <Form>
                <Form.Input label={Strings.COMPANY_NAME_1} name='executingCompanyName' value={executingCompanyName} onChange={this.handleChange} />
                <Form.Input label={Strings.RESPONSIBLE_NAME} name='executingAccountableName' value={executingAccountableName} onChange={this.handleChange} />
                <Form.Input label={Strings.TEL} name='executingTel' value={executingTel} onChange={this.handleChange} />
                <Form.Input label={Strings.EMAIL} name='executingEmail' value={executingEmail} onChange={this.handleChange} />
                <Form.Input id="executor-img" label={Strings.EXECUTING_COMPANY_LOGO} type="file" accept=".png,.jpg,.jpeg" />
              </Form>
            </Segment>

            <Segment className="ts-report-card">
              <Divider horizontal>{Strings.CONFORMITY}</Divider>
              <Dropdown
                fluid
                selection
                placeholder={Strings.DROPDOWN_PLACEHOLDER}
                options={dropdownOptions}
                onChange={this.handleConformityDropdownItemClick} />
            </Segment>

            <Segment>
              <Divider horizontal>{Strings.ANNOTATIONS}</Divider>
              <Form>
                <Form.Input type="text" name='notes' value={notes} onChange={this.handleChange} />
              </Form>
            </Segment>
          </Grid.Column>
        </Grid>

        <Button
          style={buttonStyle}
          color="teal"
          onClick={this.handleSubmit}>
          {Strings.GENERATE_REPORT}
        </Button>



        <div id="chart" style={chartsStyle}></div>
        <div id="barchart" style={chartsStyle}></div>

        <Dimmer page active={this.state.isGenerateReportDimmerActive} >
          <Loader size="big">{Strings.GENERATING_REPORT_WAITING}</Loader>
        </Dimmer>

      </div >
    );
  }
}

const chartsStyle = {
  width: "80vw",
  height: "30vh",
  display: "none",
  visibility: "hidden"
};

const divStyle = {
  margin: "2vh 2vw",
  textAlign: "center"
};

const buttonStyle = {
  margin: "2vh auto"
};

export default withRouter(Report);